<template lang="pug">
BriqTable(data-test-id="non-scheduled-products-table" class="border-style-hidden cell-padding-8-20")
  thead
    tr
      th Product
      th Quantity
      th
  tbody
    template(v-for="group in nonScheduledProductsByDeal")
      tr(data-test-id="non-scheduled-deal-row")
        td {{group.dealName}}
        td
        td
      NonScheduledProductsTableRow(
        v-for="bookingProduct in group.products"
        :key="bookingProduct.Key"
        :bookingProduct="bookingProduct"
        :nonScheduledProductOptions="nonScheduledProductOptions"
        :classifications="classifications"
        )
    NonScheduledProductsTableRow(
      v-for="bookingProduct in extrasOrWithoutDeal"
      :key="bookingProduct.Key"
      :bookingProduct="bookingProduct"
      :nonScheduledProductOptions="nonScheduledProductOptions"
      :classifications="classifications"
      @delete="p => $emit('deleteBookingProduct', p)"
      @switchNonScheduledProduct="x => $emit('switchNonScheduledProduct', x)"
      )
</template>

<script>
import NonScheduledProductsTableRow from './NonScheduledProductsTableRow.vue'
import { pipe, filter, map, groupBy, prop, both, either } from 'ramda'
import DealProductType from '@v/bookings/edit/models/DealProductType.js'

export default {
  name: 'NonScheduledProductsTable',
  components: { NonScheduledProductsTableRow },
  props: {
    nonScheduledProducts: { type: Array, required: true },
    nonScheduledProductOptions: { type: Array, required: true },
    classifications: Array,
  },
  computed: {
    nonScheduledProductsByDeal() {
      const fromDeal = p => !!p.ProductGroupKey
      const notExtra = p => p.DealProductType !== DealProductType.CrossSell
      return pipe(
        filter(both(fromDeal, notExtra)),
        groupBy(prop('ProductGroupKey')),
        Object.entries,
        map(([key, bookingProducts]) => ({
          dealKey: key,
          dealName: bookingProducts[0].ProductGroupName,
          products: bookingProducts,
        })),
      )(this.nonScheduledProducts)
    },
    extrasOrWithoutDeal() {
      const isExtra = p => p.DealProductType === DealProductType.CrossSell
      const notFromDeal = p => !p.ProductGroupKey
      return this.nonScheduledProducts.filter(either(isExtra, notFromDeal))
    },
  },
}
</script>
